import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import ServiceTypeEnum from '../../../../Enums/ServiceTypeEnum';
import selectHelper from '../../../../Helpers/selectHelper';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import { auditScheduleArray, exportsRequiredArray, mspPlatformArray, reportingRequirementsArray } from './SharedConstants';

const bareIfyPages = [
  {
    label: 'Fieldwork Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.BareIfy,
    fields: [
      {
        fieldName: 'ChecklistDetails',
        label: 'Checklist Details',
        className: 'col-12',
        type: InputTypesEnum.Text,
      },
      {
        fieldName: 'AuditSchedule',
        label: 'Audit Schedule',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(auditScheduleArray.map((a) => a.label)),
      },
      {
        fieldName: 'UserRoles',
        label: 'User Roles',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
    ],
  },
  {
    label: 'Reporting Requirements',
    hide: (item) => item.TypeCode != ServiceTypeEnum.BareIfy,
    fields: [
      {
        fieldName: 'ReportingRequirements',
        label: 'Reporting Requirements',
        className: 'col-12',
        type: InputTypesEnum.MultiChoice,
        selectvalues: reportingRequirementsArray,
      },
      {
        fieldName: 'ExportsRequired',
        label: 'Exports required?',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(exportsRequiredArray.map((e) => e.label)),
      },
      {
        fieldName: 'ActionItemsPlans',
        label: 'Action Items/Plans?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'Apirequirement',
        label: 'API requirement?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
  {
    label: 'Audit Survey',
    hide: (item) => item.TypeCode != ServiceTypeEnum.BareIfy,
    fields: [
      {
        fieldName: 'NumAuditSurveys',
        label: 'No. of Audit Surveys (Area to audit)',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'ApproxNumQuestionsPerSurvey',
        label: 'Aprox. No. of Questions per survey',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumOpenQuestions',
        label: 'No. Simple Text Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'NumNarrativeQuestions',
        label: 'No. Narrative Questions',
        className: 'col-12',
        type: InputTypesEnum.Number,
      },
      {
        fieldName: 'RequiredLanguageCode',
        label: 'Required Language(s) reporting',
        className: 'col-12',
        type: InputTypesEnum.LanguageMultiSelect,
      },
      {
        fieldName: 'DataCaptureMethodCode',
        label: 'Data Capture Method',
        className: 'col-6',
        type: InputTypesEnum.CommonDataCaptureMethodLookupItemSelect,
        validityChecker: ValidityHelper.emptyValidityChecker,
      },
      {
        fieldName: 'OtherDataCaptureMethod',
        label: 'Other Data Capture Method Description',
        className: 'col-6',
        type: InputTypesEnum.Text,
        // validityChecker: EditServiceDescription.validityCheckerforOtherDataCaptureMethodDescription, // TODO:
        hide: (item) => item.DataCaptureMethodCode != 3,
      },
      {
        fieldName: 'QuestionnaireProvided',
        label: 'Questionnaire Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'CollaborationInDataSoftware',
        label: 'Will Collaboration be used in Data Software?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
      {
        fieldName: 'Mspplatform',
        label: 'MSP Platform',
        className: 'col-12',
        type: InputTypesEnum.Select,
        selectvalues: selectHelper.generateSelectValues(mspPlatformArray.map((m) => m.label)),
        hide: (item) => item.CollaborationInDataSoftware !== 'true',
      },
      {
        fieldName: 'GuidelinesProvided',
        label: 'Guidelines Provided by Client?',
        className: 'col-12',
        type: InputTypesEnum.Bool,
      },
    ],
  },
];

export default bareIfyPages;
